module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_flower@2x-f57b119a04019437d78e1544ed6fba88.webp";